/**
 * Describes the three ways the Deduction page can fetch its list data.
 *
 * - `RemittanceGrouped`  : group-by-check is enabled AND the user is on the
 *                         "all" or "incomplete" quick-filter tabs. We fetch
 *                         remittances (parent rows) and their items load lazily.
 * - `RemittanceItemFlat` : user is on "all"/"incomplete" with group-by-check off,
 *                         OR user is on a stage-number tab. We fetch a flat list
 *                         of remittance items.
 * - Both modes share the same user-applied filter state; the resolver below
 *   picks between them purely from `{ statusId, groupByCheck }`.
 */
export enum DeductionFetchMode {
  RemittanceGrouped = "REMITTANCE_GROUPED",
  RemittanceItemFlat = "REMITTANCE_ITEM_FLAT",
}
